import { Checkbox } from "antd";
const onChange = (e) => {
  console.log(`checked = ${e.target.checked}`);
};
export default function CurrentPlanBox(props) {
  return (
    <div
      {...props}
      className="p-2 bg-white rounded-lg shadow border border-primary50 justify-start items-center gap-4 flex"
    >
      <Checkbox onChange={onChange}>
        <div className="flex-col justify-start items-start gap-1 inline-flex">
          <p className="w-[97px] text-basePrimary text-base font-semibold font-['Poppins'] leading-normal">
            {props.duration}
          </p>
          <p className="self-stretch text-[#222222] text-base font-normal font-['Poppins'] leading-normal">
            {props.contact}
          </p>
          <p className="self-stretch text-[#222222] text-base font-normal font-['Poppins'] leading-normal">
            {props.amount}
          </p>
        </div>
      </Checkbox>
    </div>
  );
}
